/**
 * Validates that a URI is a safe HTTP(S) URL suitable for use as an image src.
 */
export function isSafeImageUri(uri: string | null | undefined): boolean {
  if (!uri) return false;
  try {
    const url = new URL(typeof uri === 'string' ? uri.trim() : uri);
    return url.protocol === 'https:' || url.protocol === 'http:';
  } catch {
    return false;
  }
}
